<template>
  <div class="artinfo-comment">
    <div class="CommentTitle">
      <div class="right" v-if="isBord">
        <div class="left-line"></div>
      留言板
    </div>
      <div class="right" v-else>
        <div class="left-line"></div>
        评论
      </div>
      <div class="comment-total">
        共{{ commentTotal ? commentTotal : 0 }}条
      </div>
      <div class="hx"></div>
      <div class="like-conut">
        {{ likeTotal }}个赞
      </div>
    </div>
    <div class="uni-padding-wrap" v-if="isBord">
      <!-- 评论区 start -->
      <div class="uni-comment">
        <comment-item
          v-for="(item, index) in commentList"
          :key="index"
          :item="item"
        ></comment-item>
        <!-- <div class="nomore" v-if="commentList.length > 0">
          没有更多留言了
        </div> -->
        <div v-if="commentList.length === 0" class="nocomment">
          <van-image
                :src="require('@/assets/kong_pl.png')"
                width="140"
                height="128"
              ></van-image>
              <div class="nocommenttips">暂无留言</div>
        </div>
      </div>
    </div>
    <div class="uni-padding-wrap" v-else>
      <!-- 评论区 start -->
      <div class="uni-comment">
        <comment-item
          v-for="(item, index) in commentList"
          :key="index"
          :item="item"
        ></comment-item>
        <!-- <div class="nomore" v-if="commentList.length > 0">
          没有更多评论了
        </div> -->
        <div v-if="commentList.length === 0" class="nocomment">
          <van-image
                :src="require('@/assets/kong_pl.png')"
                width="140"
                height="128"
              ></van-image>
              <div class="nocommenttips">暂无评论</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commentItem from '@/views/artInfo/components/commentItem.vue'
export default {
  components: {
    commentItem
  },
  props: {
    commentList: {
      type: Array,
      default: () => []
    },
    commentTotal: {
      type: Number,
      default: () => {}
    },
    isBord: {
      type: Boolean,
      default: () => {}
    },
    likeTotal: {
      type: Number,
      default: 0
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
.left-line {
    width: 2px;
    height: 14px;
    background: linear-gradient(0deg, rgba(248, 243, 234, 0.3) 0%, #BCA992 100%);
    margin-right: 8px;
    display: inline-block;
}
.artinfo-comment {
  background: #fff;
  .CommentTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0 16px 0;
    .right {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      flex: 1;
    }
    .page-view,
    .like-conut, .comment-total {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
    }

    .page-view {
    }

    .hx {
      width: 1px;
      height: 13px;
      background: #b8b8b8;
      margin: 0 10px;
    }
  }
}
.nomore {
  font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #b8b8b8;
      text-align: center;
}
.nocomment {
  margin: 20px 0;
  width: 100%;
  text-align: center;
  .nocommenttips {
    color: #999;
    font-size: 12px;
    margin-top: 18px;
  }
}
</style>
